import React, { ReactNode } from "react";
import { ThemeProvider as SCThemeProvider } from "styled-components";
import light from "themes/light";
import GlobalStyles from "globalStyles";
import "fonts.css";

interface Props {
  children: ReactNode;
}

const ThemeProvider: React.FC<Props> = ({ children }) => {
  return (
    <SCThemeProvider theme={light}>
      <GlobalStyles />
      {children}
    </SCThemeProvider>
  );
};

export default ThemeProvider;
